import { UIText1 } from '@cian/ui-kit';
import * as React from 'react';
import * as styles from './ListDescription.css';

interface IListDescriptionProps {
  list: string[];
}

export const ListDescription: React.FC<IListDescriptionProps> = ({ list }) => {
  return (
    <ul className={styles['list']}>
      {list.map((text, index) => (
        <li key={index} className={styles['item']}>
          <UIText1>{text}</UIText1>
        </li>
      ))}
    </ul>
  );
};
